import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FileUploadDivComponent} from './file-upload-div.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';



@NgModule({
    declarations: [
        FileUploadDivComponent,
    ],
    exports: [
        FileUploadDivComponent
    ],
    imports: [
        CommonModule,
        ClickOutsideModule,
        MatProgressSpinnerModule
    ]
})
export class FileUploadDivModule { }
